<template>
  <div>
    <div class="dealwithDetail-title">
      <Breadcrumb>
        <BreadcrumbItem>{{$t('ApprovalTask.approvalFlowName')}}</BreadcrumbItem>
        <BreadcrumbItem to="/approvalTask">{{this.$route.query.type}}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <Form ref="dealWithForm" :model="dealWithForm" :label-width="150" :rules="ruleValidate">
      <!-- 定时开关机 -->
      <Row :gutter="10" style="margin-bottom: 10px;" v-if="this.$route.query.type=='定时开关机'">
        <Col span="24">
          <Card>
            <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">
              {{$t('schedule_instance_config.timeSwitch')}}</p>
            <!-- 定时开关机 -->
            <Row>
              <Col span="12">
                <!-- 是否例外 -->
                <FormItem :label="$t('schedule_instance_config.isException')">
                  <span style="width: 200px;">{{isException}}</span>
                </FormItem>
              </Col>
              <Col span="12">
                <!-- 是否工作日 -->
                <FormItem :label="$t('schedule_instance_config.isWorkDay')">
                  <span style="width: 200px;">{{isWorkDay}}</span>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <!-- 执行类型 -->
                <FormItem :label="$t('schedule_instance_config.performType')">
                  <span style="width: 200px;">{{performTypeDesc}}</span>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <!-- 开机时间 -->
                <FormItem :label="$t('schedule_instance_config.scheduleOpenInstanceTime')">
                  <span style="width: 200px;">{{scheduleStartTime}}</span>
                </FormItem>
              </Col>
              <Col span="12">
                <!-- 关机时间 -->
                <FormItem :label="$t('schedule_instance_config.scheduleCloseInstanceTime')">
                  <span style="width: 200px;">{{scheduleEndTime}}</span>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <!-- 例外开始日期 -->
                <FormItem :label="$t('schedule_instance_config.exceptionStartDate')">
                  <span style="width: 200px;">{{exceptionStartDate}}</span>
                </FormItem>
              </Col>
              <Col span="12">
                <!-- 例外结束日期 -->
                <FormItem :label="$t('schedule_instance_config.exceptionEndDate')">
                  <span style="width: 200px;">{{exceptionEndDate}}</span>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <!-- 例外开机时间 -->
                <FormItem :label="$t('schedule_instance_config.exceptionStartTime')">
                  <span style="width: 200px;">{{exceptionStartTime}}</span>
                </FormItem>
              </Col>
              <Col span="12">
                <!-- 例外关机时间 -->
                <FormItem :label="$t('schedule_instance_config.exceptionEndTime')">
                  <span style="width: 200px;">{{exceptionEndTime}}</span>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <!-- 状态 -->
                <FormItem :label="$t('schedule_instance_config.status')">
                  <span style="width: 200px;">{{status}}</span>
                </FormItem>
              </Col>
              <Col span="12">
                <!-- 描述 -->
                <FormItem :label="$t('schedule_instance_config.reason')">
                  <span style="width: 200px;">{{description}}</span>
                </FormItem>
              </Col>
            </Row>

            <!-- 实例 -->
            <FormItem :label="$t('schedule_instance_config.instance')" prop="instance">
              <Table :no-data-text="$t('common.noData')" :columns="columnsInstance" :data="InstancesData" :height="320"
                     style="width:100%;"></Table>
            </FormItem>
          </Card>
        </Col>
      </Row>


      <!-- 案例 -->
      <Row :gutter="10" style="margin-bottom: 10px;" v-if="this.$route.query.type=='案例'">
        <Col span="24">
          <Card>
            <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{
              $t('ticket.list.ticket') }}</p>
            <!-- 案例 -->
            <Row>
              <Col span="12">
                <!-- 问题类型 -->
                <FormItem :label="$t('ticket.list.category')">
                  <span style="width: 200px;">{{ticketCategory}}</span>
                </FormItem>
              </Col>
              <Col span="12">
                <!-- 功能类型 -->
                <FormItem :label="$t('satisfaction.functionCategory')">
                  <span style="width: 200px;">{{functionType}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="12">
                <!-- 概要 -->
                <FormItem :label="$t('satisfaction.summary')">
                  <span style="width: 200px;">{{outline}}</span>
                </FormItem>
              </Col>
              <Col span="12">
                <!-- 监控模块 -->
                <FormItem :label="$t('ticket.list.monitorModule')">
                  <span style="width: 200px;">{{monitorModule}}</span>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <!-- 优先级 -->
                <FormItem :label="$t('ticket.list.level')">
                  <span style="width: 200px;">{{priority}}</span>
                </FormItem>
              </Col>
              <Col span="12">
                <!-- 经办人 -->
                <FormItem :label="$t('ticket.list.assignee')">
                  <span style="width: 200px;">{{agent}}</span>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <!-- 描述 -->
                <FormItem :label="$t('ticket.list.description')">
                  <span style="width: 200px;">{{describe}}</span>
                </FormItem>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      <!-- 补丁 -->
      <Row :gutter="10" style="margin-bottom: 10px;" v-if="this.$route.query.type=='补丁'">
        <Col span="24">
          <Card>
            <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">
              {{$t('patch_management.patch_policy.patch')}}</p>
            <!-- 策略 -->
            <Row>
              <!-- 策略详情 -->
              <FormItem :label="$t('PatchEasy.PatchPolicy.title')" style="font-size: 17px;font-weight: 600;"></FormItem>
            </Row>
            <div style="border-bottom: 1px solid #e9e9e9;margin-bottom: 7px;">
              <Row>
                <Col span="12">
                  <!-- 策略名称 -->
                  <FormItem :label="$t('patch_management.patch_policy.title')">
                    <span style="width: 200px;">{{policyName}}</span>
                  </FormItem>
                </Col>
                <Col span="12">
                  <!-- 账户 -->
                  <FormItem :label="$t('patch_management.patch_policy.account')">
                    <span style="width: 200px;">{{account}}</span>
                  </FormItem>
                </Col>
              </Row>

              <Row>
                <Col span="12">
                  <!-- 区域 -->
                  <FormItem :label="$t('patch_management.patch_policy.region')">
                    <span style="width: 200px;">{{region}}</span>
                  </FormItem>
                </Col>
                <Col span="12">
                  <!-- 提醒时间 -->
                  <FormItem :label="$t('patch_management.patch_policy.remindTime')">
                    <span style="width: 200px;">{{remindTime}}</span>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span="12">
                  <!-- 通知对象 -->
                  <FormItem :label="$t('patch_management.patch_policy.contactPerson')">
                    <span style="width: 200px;">{{notice}}</span>
                  </FormItem>
                </Col>
                <Col span="12">
                  <!-- 日程 -->
                  <FormItem :label="$t('patch_management.patch_policy.schedule')">
                    <span style="width: 200px;">{{schedule}}</span>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span="12">
                  <!-- 描述 -->
                  <FormItem :label="$t('patch_management.patch_policy.description')">
                    <span style="width: 200px;">{{describePolicy}}</span>
                  </FormItem>
                </Col>
              </Row>
            </div>

            <!-- 命令参数 -->
            <Row>
              <!-- 命令参数详情 -->
              <FormItem :label="$t('patch_management.patch_policy.CommandParameters')"
                        style="font-size: 17px;font-weight: 600;"></FormItem>
            </Row>
            <Row>
              <Col span="12">
                <!-- 操作 -->
                <FormItem :label="$t('patch_management.patch_policy.Operating')">
                  <span style="width: 200px;">{{operating}}</span>
                </FormItem>
              </Col>
              <Col span="12">
                <!-- 是否备份 -->
                <FormItem :label="$t('patch_management.patch_policy.WhetherToBackup')">
                  <span style="width: 200px;">{{isBackup}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="12">
                <!-- 提前备份 -->
                <FormItem :label="$t('patch_management.patch_policy.InAdvance')">
                  <span
                    style="width: 200px;">{{backupInAdvance}}{{$t('patch_management.patch_policy.InAdvance')}}</span>
                </FormItem>
              </Col>
              <Col span="12">
                <!-- 备份失败是否继续 -->
                <FormItem :label="$t('patch_management.patch_policy.WhetherTheBackupFailsToContinue')">
                  <span style="width: 200px;">{{whetherBackupFailed}}</span>
                </FormItem>
              </Col>
            </Row>
            <!-- 目标 -->
            <Row style="margin-bottom: 20px;" v-if="target=='指定标签'">
              <Col span="24">
                <Row style="margin-bottom: 16px;">
                  <FormItem :label="$t('patch_management.patch_policy.WhetherTheBackupFailsToContinue')">
                    <span style="width: 200px;">{{target}}</span>
                    <!-- 指定标签 -->
                    <FormItem>
                      <Row>
                        <Col v-for="(item,index) in tags" v-bind:key="index" span="8">
                          <Tag color="default">{{item.key}} : {{item.value}}</Tag>
                        </Col>
                      </Row>
                    </FormItem>
                  </FormItem>
                </Row>
              </Col>
            </Row>
            <!-- 手动选择实例 -->
            <Row style="margin-bottom: 20px;" v-if="target=='手动选择实例'">
              <Col span="24">
                <Row style="margin-bottom: 16px;">
                  <FormItem :label="$t('patch_management.patch_policy.SpecifyTargetMethod')">
                    <span style="width: 200px;">{{target}}</span>
                    <Row>
                      <Col span="24">
                        <div>
                          <Row style="margin-bottom: 16px;">
                            <Col span="24">
                              <FormItem>
                                <Table :no-data-text="$t('common.noData')" :columns="columnsTarget"
                                       :data="tableTargetInstanceDate" :height="320"
                                       style="width:100%;"></Table>
                              </FormItem>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </FormItem>
                </Row>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      <!-- 负载均衡器未关联实例 -->
      <Row :gutter="10" style="margin-bottom: 10px;" v-if="this.$route.query.type=='负载均衡器未关联实例'">
        <Col span="24">
          <Card>
            <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">负载均衡器未关联实例详情</p>
            <!-- 负载均衡器未关联实例（ELB） -->
            <FormItem label="删除ELB未关联实例">
              <Table :no-data-text="$t('common.noData')" ref="selection" @on-selection-change="getSelectionELB"
                     :loading="loadingELB" :columns="columnsELB" :data="elbList" :height="320"
                     style="width:100%;"></Table>
            </FormItem>
          </Card>
        </Col>
      </Row>

      <!-- 实例未关联磁盘 -->
      <Row :gutter="10" style="margin-bottom: 10px;" v-if="this.$route.query.type=='实例未关联磁盘'">
        <Col span="24">
          <Card>
            <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">实例未关联磁盘详情</p>
            <!-- 实例未关联磁盘(EBS) -->
            <FormItem label="删除实例未关联磁盘">
              <Table :no-data-text="$t('common.noData')" ref="selection" @on-selection-change="getSelectionEBS"
                     :loading="loadingEBS" :columns="columnsEBS" :data="ebsList" :height="320"
                     style="width:100%;"></Table>
            </FormItem>
            <div v-if="companyIdCookie==companyId">
              <!-- 是否必须备份 -->
              <FormItem label="是否必须备份" prop="whetherBackupIsNecessary">
                <!-- TODO 暂时屏蔽 后端还未开发该功能 -->
                <!--  <RadioGroup v-model="whetherBackupIsNecessary" @on-change="changeIsBackup(whetherBackupIsNecessary)">
               <Radio v-for="list in whetherBackupIsNecessaryList" :label="list.backupResult" :key="list.value">{{list.label}}</Radio>
             </RadioGroup> -->
                <RadioGroup v-model="whetherBackupIsNecessary">
                  <Radio v-for="list in whetherBackupIsNecessaryList" :label="list.backupResult" :key="list.value">
                    {{list.label}}
                  </Radio>
                </RadioGroup>
              </FormItem>
            </div>
            <div v-else>
              <!-- 是否必须备份 -->
              <FormItem label="是否必须备份:">
                <span style="width: 200px;">{{backupResult}}</span>
              </FormItem>
            </div>

            <!-- 转移到冰川 -->
            <!-- <div v-if="whetherBackupIsNecessary===1">
              <FormItem label="转移到冰川" prop="transferToTheGlacier">
                  <label>
                      <Select v-model="transferToTheGlacier" style="width:200px;">
                          <Option :value="item.id" v-for="(item,index) in transferToTheGlacierList" v-bind:key="index">{{item.name}}</Option>
                      </Select>
                  </label>
              </FormItem>
            </div> -->
          </Card>
        </Col>
      </Row>

      <!-- 弹性IP未关联实例 -->
      <Row :gutter="10" style="margin-bottom: 10px;" v-if="this.$route.query.type=='弹性IP未关联实例'">
        <Col span="24">
          <Card>
            <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">弹性IP未关联实例详情</p>
            <!-- 弹性IP未关联实例(EIP) -->
            <FormItem label="删除弹性IP未关联实例">
              <Table :no-data-text="$t('common.noData')" ref="selection" @on-selection-change="getSelectionEIP"
                     :loading="loadingEIP" :columns="columnsEIP" :data="eipList" :height="320"
                     style="width:100%;"></Table>
            </FormItem>
          </Card>
        </Col>
      </Row>

      <!-- 预留实例购买 -->
      <!-- 预留实例购买 非最后一个节点-->
      <div v-if="this.$route.query.type=='预留实例购买'&&(this.$route.query.silverLiningNode==='false')">
        <reserved-instance ref="reservedInstance" :reservedInstanceForm="dealWithForm"></reserved-instance>
        <Row>
          <Col>
            <!-- 下一步 -->
            <Button @click="next()" style="float: right;" v-show="nextPage">下一步</Button>
          </Col>
        </Row>
      </div>
      <!-- 预留实例购买清单 最后一个节点-->
      <div v-if="this.$route.query.type=='预留实例购买'&&(this.$route.query.silverLiningNode==='true')">
        <reserved-instance-list ref="reservedInstanceList"
                                :reservedInstanceListForm="dealWithForm"></reserved-instance-list>
      </div>


      <!-- 资源申请 -->
      <!-- aws虚拟机 -->
      <amazon-virtual-machine-detail v-if="this.$route.query.type=='资源申请'&&platform==0&&lifecycleResourceType==0"
                                     ref="amazonVirtualMachine"
                                     :amazonResourceApplicationBasicInfoForm="dealWithForm"></amazon-virtual-machine-detail>
      <!-- aws虚拟网络 -->
      <amazon-virtual-network-detail v-if="this.$route.query.type=='资源申请'&&platform==0&&lifecycleResourceType==1"
                                     ref="amazonVirtualNetwork"
                                     :amazonResourceApplicationBasicInfoForm="dealWithForm"></amazon-virtual-network-detail>
      <!-- aws对象存储 -->
      <amazon-object-storage-detail v-if="this.$route.query.type=='资源申请'&&platform==0&&lifecycleResourceType==2"
                                    ref="amazonObjectStorage"
                                    :amazonResourceApplicationBasicInfoForm="dealWithForm"></amazon-object-storage-detail>
      <!-- aws托管数据库 -->
      <amazon-managed-database-detail v-if="this.$route.query.type=='资源申请'&&platform==0&&lifecycleResourceType==3"
                                      ref="amazonManagedDatabase"
                                      :amazonResourceApplicationBasicInfoForm="dealWithForm"></amazon-managed-database-detail>
      <!-- aws弹性IP -->
      <amazon-elastic-address-detail v-if="this.$route.query.type=='资源申请'&&platform==0&&lifecycleResourceType==4"
                                     ref="amazonElasticAddress"
                                     :amazonResourceApplicationBasicInfoForm="dealWithForm"></amazon-elastic-address-detail>

      <!-- azure虚拟机 -->
      <azure-virtual-machine-detail v-if="this.$route.query.type=='资源申请'&&platform==2&&lifecycleResourceType==0"
                                    ref="azureVirtualMachine"
                                    :azureResourceApplicationBasicInfoForm="dealWithForm"></azure-virtual-machine-detail>
      <!-- azure虚拟网络 -->
      <azure-virtual-network-detail v-if="this.$route.query.type=='资源申请'&&platform==2&&lifecycleResourceType==1"
                                    ref="azureVirtualNetwork"
                                    :azureResourceApplicationBasicInfoForm="dealWithForm"></azure-virtual-network-detail>
      <!-- azure对象存储 -->
      <azure-object-storage-detail v-if="this.$route.query.type=='资源申请'&&platform==2&&lifecycleResourceType==2"
                                   ref="azureObjectStorage"
                                   :azureResourceApplicationBasicInfoForm="dealWithForm"></azure-object-storage-detail>
      <!-- azure托管数据库 -->
      <azure-managed-database-detail
        v-if="this.$route.query.type=='资源申请'&&platform==2&&(lifecycleResourceType==5||lifecycleResourceType==6||lifecycleResourceType==7)"
        ref="azureManagedDatabase"
        :azureResourceApplicationBasicInfoForm="dealWithForm"></azure-managed-database-detail>
      <!-- azure弹性IP -->
      <azure-elastic-address-detail v-if="this.$route.query.type=='资源申请'&&platform==2&&lifecycleResourceType==4"
                                    ref="azureElasticAddress"
                                    :azureResourceApplicationBasicInfoForm="dealWithForm"></azure-elastic-address-detail>

      <!-- 资源变更 -->
      <resource-change-detail v-if="this.$route.query.type=='资源变更'" ref="resourceChange"
                              :resourceChangeDetailForm="dealWithForm"></resource-change-detail>

      <!-- 资源续约 -->
      <resource-renewal-detail v-if="this.$route.query.type=='资源续约'" ref="resourceRenewal"
                               :resourceRenewalDetailForm="dealWithForm"></resource-renewal-detail>

      <!-- 资源回收 -->
      <resource-recycle-detail v-if="this.$route.query.type=='资源回收'" ref="resourceRecycle"
                               :resourceRecycleDetailForm="dealWithForm"></resource-recycle-detail>


      <div v-show="showApproval">
        <!-- 预留实例购买最后一个节点显示 是否购买 -->
        <div v-if="(this.$route.query.type=='预留实例购买')&&(this.$route.query.silverLiningNode==='true')">
          <Row :gutter="10" style="margin-bottom: 10px;">
            <Col span="24">
              <Card>
                <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">是否购买</p>
                <!-- 是否购买 -->
                <FormItem label="是否购买" prop="approvResult">
                  <RadioGroup v-model="dealWithForm.approvResult">
                    <Radio v-for="list in isBuyList" :label="list.buy" :key="list.value">{{list.label}}</Radio>
                  </RadioGroup>
                </FormItem>
                <div v-if="dealWithForm.approvResult==0">
                  <!-- 不购买原因 -->
                  <FormItem label="不购买原因" prop="reason">
                    <Input v-model="dealWithForm.reason" type="textarea" :autosize="{minRows: 2,maxRows: 5}"
                           placeholder="" style="width:100%;"></Input>
                  </FormItem>
                </div>
              </Card>
            </Col>
          </Row>
        </div>
        <!-- 否则显示 审批结果 -->
        <div v-else>
          <!-- 审批 -->
          <Row :gutter="10" style="margin-bottom: 10px;">
            <Col span="24">
              <Card>
                <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">审批</p>
                <!-- 审批结果 -->
                <FormItem label="审批结果" prop="approvResult">
                  <RadioGroup v-model="dealWithForm.approvResult">
                    <Radio label="1">通过</Radio>
                    <Radio label="0">驳回</Radio>
                    <Radio label="4"
                           v-if="(this.$route.query.type=='预留实例购买')&&(this.$route.query.firstNode==='false')&&(this.$route.query.silverLiningNode==='false')">
                      返回上级节点
                    </Radio>
                  </RadioGroup>
                </FormItem>
                <div v-if="dealWithForm.approvResult==0||dealWithForm.approvResult==4">
                  <!-- 原因 -->
                  <FormItem label="原因" prop="reason">
                    <Input v-model="dealWithForm.reason" type="textarea" :autosize="{minRows: 2,maxRows: 5}"
                           placeholder="" style="width:600px;"></Input>
                  </FormItem>
                </div>
              </Card>
            </Col>
          </Row>
        </div>

        <FormItem style="float: right;">
          <!-- 上一步 -->
          <Button @click="previous()" v-if="this.$route.query.type=='预留实例购买'" :disabled="dealWithForm.isDisable"
                  v-show="previousPage">上一步
          </Button>
          <!-- 提交 -->
          <!-- 预留实例购买 提交按钮根据是否勾选 "提示语"才能点击 -->
          <Button type="primary" @click="dealWithSubmit(dealWithForm)" :disabled="dealWithForm.isDisable"
                  v-if="this.$route.query.type=='预留实例购买'">提交
          </Button>
          <!-- 否则无该逻辑 -->
          <Button type="primary" @click="dealWithSubmit(dealWithForm)" :disabled="dealWithForm.isDisable" v-else>提交
          </Button>
        </FormItem>
      </div>
    </Form>
  </div>
</template>
<script>

  import {getCookie} from '../../../utils/cookieUtil.js'
  //预留实例购买
  import ReservedInstance from "../approval_type/reserved_instance/ReservedInstance"
  //预留实例购买清单
  import ReservedInstanceList from "../approval_type/reserved_instance/ReservedInstanceList"
  /*******************资源生命周期管理*****************************/
  // AWS
  import AmazonVirtualMachineDetail
    from "../../resource_lifecycle_management/resource_application/aws/virtual_machine/AmazonVirtualMachineDetail"
  import AmazonVirtualNetworkDetail
    from "../../resource_lifecycle_management/resource_application/aws/virtual_network/AmazonVirtualNetworkDetail"
  import AmazonObjectStorageDetail
    from "../../resource_lifecycle_management/resource_application/aws/object_storage/AmazonObjectStorageDetail"
  import AmazonManagedDatabaseDetail
    from "../../resource_lifecycle_management/resource_application/aws/managed_database/AmazonManagedDatabaseDetail"
  import AmazonElasticAddressDetail
    from "../../resource_lifecycle_management/resource_application/aws/elastic_ip/AmazonElasticAddressDetail"
  // Azure
  import AzureVirtualMachineDetail
    from "../../resource_lifecycle_management/resource_application/azure/virtual_machine/AzureVirtualMachineDetail"
  import AzureVirtualNetworkDetail
    from '../../resource_lifecycle_management/resource_application/azure/virtual_network/AzureVirtualNetworkDetail'
  import AzureObjectStorageDetail
    from '../../resource_lifecycle_management/resource_application/azure/object_storage/AzureObjectStorageDetail'
  import AzureManagedDatabaseDetail
    from '../../resource_lifecycle_management/resource_application/azure/managed_database/AzureManagedDatabaseDetail'
  import AzureElasticAddressDetail
    from '../../resource_lifecycle_management/resource_application/azure/elastic_ip/AzureElasticAddressDetail'
  // 资源变更
  import ResourceChangeDetail from '../../resource_lifecycle_management/resource_change/ResourceChangeDetail'
  // 资源续约
  import ResourceRenewalDetail from '../../resource_lifecycle_management/resource_renewal/ResourceRenewalDetail'
  // 资源回收
  import ResourceRecycleDetail from '../../resource_lifecycle_management/resource_recycle/ResourceRecycleDetail'
  import utils from '../../../utils/utils.js'

  var tableApprovalTaskVue = {};
  export default {
    name: 'DealwithDetail',
    components: {
      AmazonVirtualMachineDetail,
      AmazonVirtualNetworkDetail,
      AmazonObjectStorageDetail,
      AmazonManagedDatabaseDetail,
      AmazonElasticAddressDetail,
      AzureVirtualMachineDetail,
      AzureVirtualNetworkDetail,
      AzureObjectStorageDetail,
      AzureManagedDatabaseDetail,
      AzureElasticAddressDetail,
      ResourceChangeDetail,
      ResourceRenewalDetail,
      ResourceRecycleDetail,
      ReservedInstance,
      ReservedInstanceList
    },
    data() {
      return {
        previousPage: false, //上一步
        nextPage: false, //下一步
        showApproval: false, //审批
        platform: '',
        lifecycleResourceType: '',//资源申请
        backupResult: '',
        companyId: '',
        companyIdCookie: getCookie(global.companyId),
        selectionELB: '',
        selectionEBS: '',
        selectionEIP: '',
        loadingELB: false,
        loadingEBS: false,
        loadingEIP: false,
        // transferToTheGlacier:'',
        transferToTheGlacierList: [],
        whetherBackupIsNecessary: 0,
        whetherBackupIsNecessaryList: [{
          label: this.$t('common.yes'),
          value: 'adopt',
          backupResult: 1
        }, {
          label: this.$t('common.no'),
          value: 'reject',
          backupResult: 0
        }],//是否必须备份
        isException: '',
        isWorkDay: '',
        performTypeDesc: '',
        exceptionStartTime: '',
        exceptionEndTime: '',
        exceptionStartDate: '',
        exceptionEndDate: '',
        scheduleStartTime: '',
        scheduleEndTime: '',
        status: '',
        description: '',
        InstancesData: [],
        dealWithForm: {
          approvResult: '1',
          reason: '',
          processTaskId: this.$route.query.id,
          id: this.$route.query.taskId,
          isDisable: false//点击提交
        },
        isBuyList: [{
          label: this.$t('schedule_instance_config.yes'),
          value: 'adopt',
          buy: '1'
        }, {
          label: this.$t('schedule_instance_config.no'),
          value: 'reject',
          buy: '0'
        }],
        columnsInstance: [{
          title: this.$t('schedule_instance_config.ip'),
          key: 'privateIp'
        },
          {
            title: this.$t('schedule_instance_config.instanceName'),
            key: 'name'
          },
          {
            title: this.$t('schedule_instance_config.instanceStatus'),
            key: 'detailPurpose'
          }],
        ruleValidate: {
          approvResult: [
            {required: true, message: '请选择审批结果', trigger: 'change'}
          ],
          reason: [
            {required: true, message: '请输入原因', trigger: 'blur'},
            {type: 'string', max: 100, message: '最多输入100个字符', trigger: 'blur'}
          ]
        },
        ticketCategory: '', //案例
        functionType: '',
        outline: '',
        monitorModule: '',
        priority: '',
        agent: '',
        describe: '',
        policyName: '',  //策略
        account: '',
        region: '',
        remindTime: '',
        notice: '',
        schedule: '',
        describePolicy: '',
        operating: '',   //命令参数
        isBackup: '',
        backupInAdvance: '',
        whetherBackupFailed: '',
        target: '',
        tags: [],
        tableTargetInstanceDate: [],
        columnsTarget: [{
          title: this.$t('patch_management.patch_policy.name'),
          key: 'name'
        },
          {
            title: this.$t('patch_management.patch_policy.InstanceID'),
            key: 'instanceId'
          },
          {
            title: this.$t('patch_management.patch_policy.ProxyVersion'),
            key: 'agentVersion'
          },
          {
            title: this.$t('patch_management.patch_policy.status'),
            key: 'state'
          },
          {
            title: this.$t('patch_management.patch_policy.AvailableArea'),
            key: 'availabilityZone'
          },
          {
            title: this.$t('patch_management.patch_policy.platform'),
            key: 'platform'
          }],
        columnsELB: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: 'AccountName',
            key: 'accountName'
          },
          {
            title: 'Region',
            key: 'region'
          },
          {
            title: 'LoadBalance Name',
            key: 'name'
          },
          {
            title: 'DNS Name',
            key: 'dnsName'
          },
          {
            title: 'VPCId',
            key: 'vpcId'
          }],
        newELBDataList: [],
        elbList: [],  //ELB
        columnsEIP: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: 'AccountName',
            key: 'accountName'
          },
          {
            title: 'Region',
            key: 'region'
          },
          {
            title: 'AllocationId',
            key: 'allocationId'
          },
          {
            title: 'PublicIp',
            key: 'publicIp'
          }],
        newEIPDataList: [],
        eipList: [], //EIP
        columnsEBS: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: 'AccountName',
            key: 'accountName'
          },
          {
            title: 'volumeAwsId',
            key: 'volumeAwsId'
          },
          {
            title: 'capacity',
            key: 'capacity'
          },
          {
            title: 'type',
            key: 'type'
          },
          {
            title: 'iops',
            key: 'iops'
          },
          {
            title: 'region',
            key: 'region'
          }],
        newEBSDataList: [],
        ebsList: []
      }
    },
    beforeCreate: function () {
      tableApprovalTaskVue = this
    },
    mounted: function () {
      if (this.$route.query.type != '预留实例购买') {
        tableApprovalTaskVue.dealWithLine();
        this.showApproval = true;
      } else if ((this.$route.query.type == '预留实例购买') && (this.$route.query.silverLiningNode === 'true')) {
        this.showApproval = true;
      } else if ((this.$route.query.type == '预留实例购买') && (this.$route.query.silverLiningNode === 'false')) {
        this.nextPage = true;
      }
    },
    methods: {
      // 上一步
      previous: function () {
        // 显示下一步
        this.nextPage = true;
        this.$refs.reservedInstance.previous();
        if (this.$refs.reservedInstance.isPrevious == true && this.$refs.reservedInstance.isNext == false) {
          this.showApproval = false;
        }
      },
      // 下一步
      next: function () {
        // 隐藏下一步
        this.nextPage = false;
        this.$refs.reservedInstance.next();
        // 显示下一步
        this.previousPage = true;
        if (this.$refs.reservedInstance.isPrevious == false && this.$refs.reservedInstance.isNext == true) {
          this.showApproval = true;
        }

        // 接口数组与最后修改数组不一致显示 提示
        for (var i = 0; i < this.$refs.reservedInstance.newReservedDataList.length; i++) {
          // 当匹配类型为"原始数据"或者linuxServerFlag为"false" 显示"数量"字段
          if (this.$refs.reservedInstance.customizeReservedInstanceSaveType == 0 || this.$refs.reservedInstance.newReservedDataList[i].linuxServerFlag == false) {
            if ((this.$refs.reservedInstance.newReservedDataList[i].actualPurchasedQuantity != this.$refs.reservedInstance.newReservedDataList[i].instanceCount) || (this.$refs.reservedInstance.newReservedDataList.length != this.$refs.reservedInstance.isBuyReservedInstancesData.length)) {
              // 显示提示
              this.$refs.reservedInstance.showTip = true;
              break;
            } else {
              // 隐藏提示
              this.$refs.reservedInstance.showTip = false;
            }
          }
          // 当匹配类型为"标准化因子"且linuxServerFlag为"true" 显示"标准化因子"字段
          else if (this.$refs.reservedInstance.customizeReservedInstanceSaveType == 1 && this.$refs.reservedInstance.newReservedDataList[i].linuxServerFlag == true) {
            if ((this.$refs.reservedInstance.newReservedDataList[i].actualPurchasedQuantity != this.$refs.reservedInstance.newReservedDataList[i].normalizationFactor) || (this.$refs.reservedInstance.newReservedDataList.length != this.$refs.reservedInstance.isBuyReservedInstancesData.length)) {
              // 显示提示
              this.$refs.reservedInstance.showTip = true;
              break;
            } else {
              // 隐藏提示
              this.$refs.reservedInstance.showTip = false;
            }
          }
        }
      },
      /**************************处理******************************/
      // 处理
      dealWithLine: function () {
        // 审批
        this.$api.processTask.approvalReview({
          "processTaskId": this.$route.query.id,
        })
          .then(res => {
            if (this.$route.query.type == '案例') {
              // 问题类型
              this.ticketCategory = res.data.ticket.ticketCategoryName;
              // 功能类型
              this.functionType = res.data.ticket.functionTypeName;
              // 概要
              this.outline = res.data.ticket.subject;
              // 监控模块
              this.monitorModule = res.data.ticket.monitorModuleName;
              // 优先级
              this.priority = res.data.ticket.priorityName;
              // 经办人
              this.agent = res.data.ticket.assigneeUserName;
              // 描述
              this.describe = res.data.ticket.description;

            } else if (this.$route.query.type == '补丁') {
              /****************策略详情*****************************/
              // 策略名称
              this.policyName = res.data.policyDate.policyDetail.name;
              // 账户
              this.account = res.data.policyDate.policyDetail.accountName;
              // 区域
              this.region = res.data.policyDate.policyDetail.region;
              // 提醒时间
              this.remindTime = res.data.policyDate.policyDetail.remindNames;
              // 通知对象
              this.notice = res.data.policyDate.policyDetail.contactIDNames;
              // 日程
              this.schedule = res.data.policyDate.policyDetail.scheduleManagementName;
              // 描述
              this.describePolicy = res.data.policyDate.policyDetail.description;
              /****************命令参数详情*****************************/
              // 操作
              if (res.data.policyDate.patchCommandPropertyDetail.operation == 0) {
                this.operating = 'Scan';
              } else if (res.data.policyDate.patchCommandPropertyDetail.operation == 1) {
                this.operating = 'Install';
              }
              // 是否备份
              if (res.data.policyDate.patchCommandPropertyDetail.isBackup == 0) {
                this.isBackup = this.$t('common.yes');
              } else if (res.data.policyDate.patchCommandPropertyDetail.isBackup == 1) {
                this.isBackup = this.$t('common.no');
              }
              // 提前备份
              this.backupInAdvance = res.data.policyDate.patchCommandPropertyDetail.backupTime;
              // 备份失败是否继续
              if (res.data.policyDate.patchCommandPropertyDetail.isBackupFailedContinue) {
                this.whetherBackupFailed = this.$t('common.yes');
              } else {
                this.whetherBackupFailed = this.$t('common.no');
              }
              // 指定目标方式
              if (res.data.policyDate.patchCommandPropertyDetail.targetType == 0) {
                this.target = '指定标签';
                this.tags = res.data.policyDate.patchCommandPropertyDetail.tags;
              } else if (res.data.policyDate.patchCommandPropertyDetail.targetType == 1) {
                this.target = '手动选择实例';
                this.tableTargetInstanceDate = res.data.policyDate.patchCommandPropertyDetail.instanceDTOS;
                for (var i = 0; i < this.tableTargetInstanceDate.length; i++) {
                  // 状态
                  if (this.tableTargetInstanceDate[i].state == 0) {
                    this.tableTargetInstanceDate[i].state = 'pending';
                  } else if (this.tableTargetInstanceDate[i].state == 1) {
                    this.tableTargetInstanceDate[i].state = 'running';
                  } else if (this.tableTargetInstanceDate[i].state == 2) {
                    this.tableTargetInstanceDate[i].state = 'stopping';
                  } else if (this.tableTargetInstanceDate[i].state == 3) {
                    this.tableTargetInstanceDate[i].state = 'stopped';
                  } else if (this.tableTargetInstanceDate[i].state == 4) {
                    this.tableTargetInstanceDate[i].state = 'shutting down';
                  } else if (this.tableTargetInstanceDate[i].state == 5) {
                    this.tableTargetInstanceDate[i].state = 'terminated';
                  }
                }
              }

            } else if (this.$route.query.type == '定时开关机') {
              //状态
              if (res.data.timerSwitchs.status === 0) {
                this.status = '启动';
              } else if (res.data.timerSwitchs.status == 1) {
                this.status = '暂停';
              } else if (res.data.timerSwitchs.status == 2) {
                this.status = '关闭';
              } else if (res.data.timerSwitchs.status == 3) {
                this.status = '例外';
              }
              //执行类型
              this.performTypeDesc = res.data.timerSwitchs.performTypeDesc;
              // 开机时间
              this.scheduleStartTime = res.data.timerSwitchs.scheduleStartTime;
              // 关机时间
              this.scheduleEndTime = res.data.timerSwitchs.scheduleEndTime;
              // 申请原因
              this.description = res.data.timerSwitchs.description;
              // 实例
              this.InstancesData = res.data.timerSwitchs.instanceDTOS;

              //是否例外
              if (res.data.timerSwitchs.isException) {
                // 例外开机时间
                this.exceptionStartTime = res.data.timerSwitchs.exceptionStartTime;
                // 例外关机时间
                this.exceptionEndTime = res.data.timerSwitchs.exceptionEndTime;
                // 例外开始日期
                this.exceptionStartDate = utils.methods.formatDate(res.data.timerSwitchs.exceptionStartDate);
                // 例外结束日期
                this.exceptionEndDate = utils.methods.formatDate(res.data.timerSwitchs.exceptionEndDate);
                this.isException = this.$t('common.yes');
              } else {
                this.isException = this.$t('common.no');
                this.exceptionStartTime = '---';
                this.exceptionEndTime = '---';
                this.exceptionStartDate = '---';
                this.exceptionEndDate = '---';
              }
              //是否工作日
              if (res.data.timerSwitchs.isWorkdays) {
                this.isWorkDay = this.$t('common.yes');
              } else {
                this.isWorkDay = this.$t('common.no');
              }

              //如果没有开机时间 关机时间
              if (res.data.timerSwitchs.scheduleStartTime == undefined || res.data.timerSwitchs.scheduleEndTime == undefined) {
                this.scheduleStartTime = '---';
                this.scheduleEndTime = '---';
              }
            } else if (this.$route.query.type == '负载均衡器未关联实例') {
              this.listNotAttachedResources(this.$route.query.id, this.$route.query.type);
            } else if (this.$route.query.type == '实例未关联磁盘') {
              this.listNotAttachedResources(this.$route.query.id, this.$route.query.type);
            } else if (this.$route.query.type == '弹性IP未关联实例') {
              this.listNotAttachedResources(this.$route.query.id, this.$route.query.type);
            } else if (this.$route.query.type == '资源申请') {
              //云平台
              this.platform = res.data.lifecycleResource.platform;
              //资源类型
              this.lifecycleResourceType = res.data.lifecycleResource.lifecycleResourceType;
            }
          })
      },
      /**********************查询未挂载资源列表******************************/
      // 查询未挂载资源列表
      listNotAttachedResources: function (processTaskId, processTypeName) {
        this.loadingELB = true;
        this.loadingEBS = true;
        this.loadingEIP = true;
        this.companyId = '';

        this.$api.resourceNotAttached.selectNotAttached({
          "processTypeName": processTypeName,
          "processTaskId": processTaskId,
        })
          .then(res => {
            this.companyId = res.data.companyId;
            if (processTypeName === '负载均衡器未关联实例') {
              this.elbList = res.data.loadBalancerDTOList;
              this.loadingELB = false;
              // 清空数组
              this.newELBDataList = [];
              for (var i = 0; i < this.elbList.length; i++) {
                if (this.elbList[i].state === 1) {
                  this.elbList[i]._checked = true;
                  // 如果当前用户的公司id和接口返回的公司id不一样 不能编辑checkbox
                  if (this.companyIdCookie != this.companyId) {
                    this.elbList[i]._disabled = true;
                  }
                  var TableELBCopy = new Object();
                  TableELBCopy.accountId = this.elbList[i].accountId;
                  TableELBCopy.accountName = this.elbList[i].accountName;
                  TableELBCopy.dnsName = this.elbList[i].dnsName;
                  TableELBCopy.name = this.elbList[i].name;
                  TableELBCopy.region = this.elbList[i].region;
                  TableELBCopy.vpcId = this.elbList[i].vpcId;
                  TableELBCopy.state = this.elbList[i].state;
                  this.newELBDataList.push(TableELBCopy);
                }
              }
            } else if (processTypeName === '实例未关联磁盘') {
              this.ebsList = res.data.volumeDTOList;
              if (res.data.backupResult === 0) {
                this.backupResult = this.$t('common.no');
              } else if (res.data.backupResult === 1) {
                this.backupResult = this.$t('common.yes');
              }
              this.loadingEBS = false;
              // 清空数组
              this.newEBSDataList = [];
              for (var i = 0; i < this.ebsList.length; i++) {
                if (this.ebsList[i].state === 1) {
                  this.ebsList[i]._checked = true;
                  // 如果当前用户的公司id和接口返回的公司id不一样 不能编辑checkbox
                  if (this.companyIdCookie != this.companyId) {
                    this.ebsList[i]._disabled = true;
                  }
                  var TableEBSCopy = new Object();
                  TableEBSCopy.accountId = this.ebsList[i].accountId;
                  TableEBSCopy.accountName = this.ebsList[i].accountName;
                  TableEBSCopy.capacity = this.ebsList[i].capacity;
                  TableEBSCopy.createdTime = this.ebsList[i].createdTime;
                  TableEBSCopy.encrypted = this.ebsList[i].encrypted;
                  TableEBSCopy.gp2Cost = this.ebsList[i].gp2Cost;
                  TableEBSCopy.io1Cost = this.ebsList[i].io1Cost;
                  TableEBSCopy.iops = this.ebsList[i].iops;
                  TableEBSCopy.region = this.ebsList[i].region;
                  TableEBSCopy.state = this.ebsList[i].state;
                  TableEBSCopy.stateName = this.ebsList[i].stateName;
                  TableEBSCopy.type = this.ebsList[i].type;
                  TableEBSCopy.unitPrice = this.ebsList[i].unitPrice;
                  TableEBSCopy.volumeAwsId = this.ebsList[i].volumeAwsId;
                  TableEBSCopy.state = this.ebsList[i].state;
                  this.newEBSDataList.push(TableEBSCopy);
                }
              }
            } else if (processTypeName === '弹性IP未关联实例') {
              this.eipList = res.data.addressDTOList;
              this.loadingEIP = false;
              // 清空数组
              this.newEIPDataList = [];
              for (var i = 0; i < this.eipList.length; i++) {
                if (this.eipList[i].state === 1) {
                  this.eipList[i]._checked = true;
                  // 如果当前用户的公司id和接口返回的公司id不一样 不能编辑checkbox
                  if (this.companyIdCookie != this.companyId) {
                    this.eipList[i]._disabled = true;
                  }

                  var TableEIPCopy = new Object();
                  TableEIPCopy.accountId = this.eipList[i].accountId;
                  TableEIPCopy.accountName = this.eipList[i].accountName;
                  TableEIPCopy.allocationId = this.eipList[i].allocationId;
                  TableEIPCopy.publicIp = this.eipList[i].publicIp;
                  TableEIPCopy.region = this.eipList[i].region;
                  this.newEIPDataList.push(TableEIPCopy);
                }
              }
            }
          });
      },
      // TODO 暂时屏蔽 后端还未开发该功能
      // 处理"未挂在资源"时，切换是否备份事件
      // changeIsBackup:function(){
      //     //当备份时 显示转移到冰川
      //     if(this.whetherBackupIsNecessary === 1){
      //         this.$api.resourceNotAttached.getBackupTime({})
      //         .then(res => {
      //             this.transferToTheGlacierList = res.data;
      //             this.transferToTheGlacier=this.transferToTheGlacierList[0].id;
      //         })
      //     }
      // },
      // 当前选择checkbox
      getSelectionELB: function (selection) {
        this.selectionELB = selection;
        // 清空数组
        this.newELBDataList = [];
        for (var i = 0; i < this.selectionELB.length; i++) {
          var TableELBCopy = new Object();
          TableELBCopy.accountId = this.selectionELB[i].accountId;
          TableELBCopy.accountName = this.selectionELB[i].accountName;
          TableELBCopy.dnsName = this.selectionELB[i].dnsName;
          TableELBCopy.name = this.selectionELB[i].name;
          TableELBCopy.region = this.selectionELB[i].region;
          TableELBCopy.vpcId = this.selectionELB[i].vpcId;
          TableELBCopy.state = this.selectionELB[i].state;
          this.newELBDataList.push(TableELBCopy);
        }
      },
      // 当前选择checkbox
      getSelectionEBS: function (selection) {
        this.selectionEBS = selection;
        // 清空数组
        this.newEBSDataList = [];
        for (var i = 0; i < this.selectionEBS.length; i++) {
          var TableEBSCopy = new Object();
          TableEBSCopy.accountId = this.selectionEBS[i].accountId;
          TableEBSCopy.accountName = this.selectionEBS[i].accountName;
          TableEBSCopy.capacity = this.selectionEBS[i].capacity;
          TableEBSCopy.createdTime = this.selectionEBS[i].createdTime;
          TableEBSCopy.encrypted = this.selectionEBS[i].encrypted;
          TableEBSCopy.gp2Cost = this.selectionEBS[i].gp2Cost;
          TableEBSCopy.io1Cost = this.selectionEBS[i].io1Cost;
          TableEBSCopy.iops = this.selectionEBS[i].iops;
          TableEBSCopy.region = this.selectionEBS[i].region;
          TableEBSCopy.state = this.selectionEBS[i].state;
          TableEBSCopy.stateName = this.selectionEBS[i].stateName;
          TableEBSCopy.type = this.selectionEBS[i].type;
          TableEBSCopy.unitPrice = this.selectionEBS[i].unitPrice;
          TableEBSCopy.volumeAwsId = this.selectionEBS[i].volumeAwsId;
          TableEBSCopy.state = this.selectionEBS[i].state;
          this.newEBSDataList.push(TableEBSCopy);
        }
      },
      // 当前选择checkbox
      getSelectionEIP: function (selection) {
        this.selectionEIP = selection;
        // 清空数组
        this.newEIPDataList = [];
        for (var i = 0; i < this.selectionEIP.length; i++) {
          var TableEIPCopy = new Object();
          TableEIPCopy.accountId = this.selectionEIP[i].accountId;
          TableEIPCopy.accountName = this.selectionEIP[i].accountName;
          TableEIPCopy.allocationId = this.selectionEIP[i].allocationId;
          TableEIPCopy.publicIp = this.selectionEIP[i].publicIp;
          TableEIPCopy.region = this.selectionEIP[i].region;
          this.newEIPDataList.push(TableEIPCopy);
        }
      },
      /**************************提交******************************/
      // 提交
      dealWithSubmit: function (name) {
        this.dealWithForm.isDisable = true;
        this.$refs.dealWithForm.validate(valid => {
          if (valid) {
            var approvalProcessDate = {
              "processTaskId": this.$route.query.id,
              "state": parseInt(this.dealWithForm.approvResult),
              "reason": this.dealWithForm.reason
            };

            if (this.$route.query.type == '负载均衡器未关联实例') {
              approvalProcessDate.loadBalancerDTOList = this.newELBDataList;
            } else if (this.$route.query.type == '实例未关联磁盘') {
              approvalProcessDate.backupResult = this.whetherBackupIsNecessary;
              // approvalProcessDate.transferToTheGlacier=this.transferToTheGlacier;
              approvalProcessDate.volumeDTOList = this.newEBSDataList;
            } else if (this.$route.query.type == '弹性IP未关联实例') {
              approvalProcessDate.addressDTOList = this.newEIPDataList;
            }
            // 预留实例购买
            else if ((this.$route.query.type == '预留实例购买') && (this.$route.query.silverLiningNode === 'false')) {
              approvalProcessDate.riPurchaseListIsLessThanOriginalDataList = this.$refs.reservedInstance.showTip;
              approvalProcessDate.reservedInstanceDTO = {
                "saveType": this.$refs.reservedInstance.customizeReservedInstanceSaveType,
                "waitingForPurchaseReservedInstanceDTOs": this.$refs.reservedInstance.newReservedDataList
              }
            }
            // 预留实例购买清单
            else if ((this.$route.query.type == '预留实例购买') && (this.$route.query.silverLiningNode === 'true')) {
              approvalProcessDate.riPurchaseListIsLessThanOriginalDataList = this.$refs.reservedInstanceList.showTip;
              approvalProcessDate.reservedInstanceDTO = {
                "saveType": this.$refs.reservedInstanceList.matchType,
                "waitingForPurchaseReservedInstanceDTOs": this.$refs.reservedInstanceList.newDataList
              }
            }

            // 审批
            this.$api.processOperationLog.approvalProcess(approvalProcessDate)
              .then(res => {
                setTimeout(() => {
                  this.$refs.dealWithForm.resetFields();
                  this.$Message.success('审批成功');
                  this.dealWithForm.isDisable = false;
                  this.$router.push({path: '/approvalTask', query: {t: Date.now()}});
                }, 1000);
              }, error => {
                if (error.status != 200) {
                  this.dealWithForm.isDisable = false;
                }
              })
          } else {
            this.$Message.error('审批失败');
            this.dealWithForm.isDisable = false;
          }
        });
      }
    }
  }
</script>
<style scoped>
  .dealwithDetail-title {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 15px 0px 15px 4px;
  }

  .ivu-breadcrumb {
    font-size: 13px;
    font-weight: 600;
    color: #515a6e;
  }

  .ivu-form-item {
    margin-bottom: 10px !important;
    vertical-align: top;
    zoom: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/approval_task/approval_task/DealwithDetail.vue